<template>
  <div style="margin-bottom: 170px">
    <!-- top search bar -->
    <div class="pa-5 d-flex">
      <div class="form-input-group flex-grow-1 mr-5">
        <v-icon class="prepend-icon" style="top: 45%;">search</v-icon>
        <input
          type="text"
          class="pl-42px"
          placeholder="搜尋"
          v-model="filter.keyword"
        />
      </div>
      <DateFilter
        buttonPlaceholder="篩選日期區間"
        class="w-220px mr-5"
        :dateOfRegisterFilter.sync="filter.createdAtRange"
      ></DateFilter>
      <SimpleSelectWithSearchInput
        class="mr-5"
        buttonPlaceholder="篩選國別"
        buttonWidth="140px"
        :isOnlyShowButtonPlaceholder="true"
        :options="countryOptions"
        :selectedValue.sync="filter.country"
        item-value="country"
        item-text="country"
      ></SimpleSelectWithSearchInput>
      <SegmentalControls
        class="mr-5"
        v-model="filter.isSubscription"
      ></SegmentalControls>
      <button class="btn btn-primary w-88px" @click="getMembers">搜尋</button>
    </div>
    <!-- filter condition -->
    <div class="px-5 pb-5 d-flex" v-if="filter.country != null">
      <div
        class="h5 ink-02-medium--text h-32px w-70px d-flex align-center flex-shrink-0"
      >
        篩選條件：
      </div>
      <div class="flex-wrap">
        <!-- countryFilter -->
        <v-chip
          v-if="filter.country != null"
          close
          class="ml-5 mb-2"
          @click:close="filter.country = null"
        >
          {{ filter.country }}
        </v-chip>
      </div>
    </div>

    <!-- table -->
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <div v-if="lengthOfisCheckedList > 0"
             class="form-item d-flex align-center px-5 h-60px batch">
          <h5 class="col-checkbox">
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </h5>
          <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
          <div>
            <button
              class="btn btn-outline danger-500--text"
              :style="{
                border: '1px solid #f60000',
                width: '117px',
              }"
              @click="multiToggleMemberSubscribe"
            >
              Unsubscribe
            </button>
          </div>
        </div>
        <tr>
          <th>
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </th>
          <th class="text-left">Name</th>
          <th class="text-left">Email</th>
          <th class="text-left">國別</th>
          <th class="text-left">Unsubscribe</th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in members"
          :key="item.id"
        >
          <td>
            <v-checkbox v-model="item.isChecked"></v-checkbox>
          </td>
          <td>{{ item.last_name }} {{ item.first_name }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.country }}</td>
          <td>
            <button
              v-if="item.is_subscription"
              class="btn btn-outline danger-500--text"
              :style="{
                border: '1px solid #f60000',
                width: '117px',
              }"
              @click="toggleMemberSubscribe(item.id)"
            >
              Unsubscribe
            </button>
            <span v-else>未訂閱</span>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- table footer -->
    <Pagination @handleNextPreEvent="getMembers" model="member"></Pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import DateFilter from '@/components/F-1a__ADATA-members_Filter-StartEndDate.vue';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import SegmentalControls from '@/components/SegmentalControls.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  components: {
    DateFilter,
    SimpleSelectWithSearchInput,
    SegmentalControls,
    Pagination,
  },
  data: () => ({
    // filter
    checkAllStatus: false, // left top checkbox status
  }),
  computed: {
    ...mapState('member', ['members', 'filter', 'countryOptions']),
    lengthOfisCheckedList() {
      return this.members.filter((item) => item.isChecked)
        .length;
    },
    indeterminate() {
      const isCheckedList = this.members.filter(
        (item) => item.isChecked,
      );
      if (
        isCheckedList.length === 0 ||
        isCheckedList.length === this.members.length
      ) {
        return false;
      }
      return true;
    },
    isCheckedListIds() {
      return this.members.filter((item) => item.isChecked).map((item) => item.id);
    },
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.members.length) {
        this.checkAllStatus = false;
      }
      if (newValue === this.members.length) {
        this.checkAllStatus = true;
      }
    },
  },
  methods: {
    ...mapActions('member', {
      getMembers: 'find',
      toggleSubscribe: 'toggleSubscribe',
    }),
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        this.members.forEach(
          (item) => (item.isChecked = true),
        );
      } else {
        this.members.forEach(
          (item) => (item.isChecked = false),
        );
      }
    },
    toggleMemberSubscribe(id) {
      this.toggleSubscribe(id).then(() => this.getMembers());
    },
    async multiToggleMemberSubscribe() {
      await this.isCheckedListIds.forEach((id) => {
        this.toggleSubscribe(id).then(() => {});
      });
      this.getMembers();
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-name {
    width: 220px;
    margin-right: 20px;
    overflow-wrap: break-word;
  }
  .col-email {
    width: 220px;
    margin-right: 20px;
    overflow-wrap: break-word;
  }
  .col-country {
    width: 150px;
    overflow-wrap: break-word;
  }
  .col-unsubscribe {
    width: 120px;
    margin-left: auto;
    text-align: center;
  }
}
</style>
